var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useContext, useEffect, useState } from 'react';
import { BlockchainState, CardAdvancement, CardBattleSortName, CardGrade, ImxPendingBurnStatus, SortOrderDirection, } from '@cta-portal/webapp-common/src/api/schema';
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import cardsData from '../../data/products/cards.json';
import { generateCardImgUrl, getAvailableRanksFromRarity } from '../../utils/products';
import { LoadingContext } from '../../context/loading';
import { getAssetSplittedFloorPrices } from '../../utils/imx-orders';
import { CurrencyContext } from '../../context/currency';
import { UserContext } from '../../context/user';
import { TokenType } from '../../types/common';
import { CurrencyTokenSymbol } from '../../data/currency-tokens/currency-tokens';
import { DialogType } from '../../types/dialogs';
import { checkIfWalletAsEnoughCurrency } from '../../utils/balances';
import { DialogContext } from '../../context/dialog';
import { useImxActions } from '../imx/use-imx-actions';
import { useI18n } from '@cta-portal/webapp-common/src/hooks/translations/use-i18n';
import { sleep } from '../../utils/async';
import { WalletConnectionType } from '../../types/blockchain';
import { burnPendingBurn } from '../../utils/pending-burns';
export var CraftType;
(function (CraftType) {
    CraftType["POWER_UP"] = "POWER_UP";
    CraftType["AWAKENING"] = "AWAKENING";
    CraftType["MERGE"] = "MERGE";
})(CraftType || (CraftType = {}));
export function useCraft(ian) {
    var _a;
    var _this = this;
    var t = useI18n().t;
    var _b = useContext(LoadingContext), setImxLoading = _b.setImxLoading, setServerLoading = _b.setServerLoading;
    var _c = useContext(DialogContext), dialogProps = _c.dialogProps, setDialogProps = _c.setDialogProps;
    var _d = useContext(UserContext), user = _d.user, fees = _d.fees, balances = _d.balances, selectedWallet = _d.selectedWallet, localWalletAddress = _d.localWalletAddress, setSelectedWallet = _d.setSelectedWallet;
    var _e = useContext(CurrencyContext), imxClient = _e.imxClient, usdcAddress = _e.usdcAddress, queue = _e.queue, parseCurrencyQuantity = _e.parseCurrencyQuantity;
    var imxActions = useImxActions();
    var _f = useState(undefined), targetCard = _f[0], setTargetCard = _f[1];
    var _g = useState(undefined), craftType = _g[0], setCraftType = _g[1];
    var _h = useState(2), targetRank = _h[0], setTargetRank = _h[1];
    var _j = useState(CardGrade.C), targetGrade = _j[0], setTargetGrade = _j[1];
    var _k = useState(false), targetFoil = _k[0], setTargetFoil = _k[1];
    // const [usdAmount] = useState<number>(22.22)
    var _l = useState(0), stoneAmount = _l[0], setStoneAmount = _l[1];
    var _m = useState(0), triselAmount = _m[0], setTriselAmount = _m[1];
    var _o = useState(false), acceptTerms = _o[0], setAcceptTerms = _o[1];
    var _p = useState([]), cardsToSelect = _p[0], setCardsToSelect = _p[1];
    var _q = useState(undefined), resultedCard = _q[0], setResultedCard = _q[1];
    var _r = useState((_a = {}, _a[CurrencyTokenSymbol.CTA] = undefined, _a[CurrencyTokenSymbol.USDC] = undefined, _a)), floorPrices = _r[0], setFloorPrices = _r[1];
    var _s = useState(CurrencyTokenSymbol.CTA), selectedCurrency = _s[0], setSelectedCurrency = _s[1];
    var getCardsToSelect = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var result, cardIans, ranks, grades, _loop_1, _i, cardIans_1, ian_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!targetCard) {
                        setCardsToSelect([]);
                        return [2 /*return*/];
                    }
                    setServerLoading(true);
                    setSelectedWallet((user === null || user === void 0 ? void 0 : user.mpcWalletAddress) || undefined);
                    result = [];
                    cardIans = [];
                    if (targetCard.advancement !== CardAdvancement.STANDARD) {
                        cardIans = __spreadArray([], targetCard.reagentsIan, true);
                    }
                    else {
                        cardIans = [targetCard.ian];
                    }
                    ranks = [1, 2, 3, 4, 5];
                    grades = [CardGrade.C, CardGrade.B, CardGrade.A, CardGrade.S];
                    _loop_1 = function (ian_1) {
                        var cardData, targetGradeIndex, filters, cards, resultedCard_1;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    cardData = cardsData.find(function (card) { return card.ian === ian_1; });
                                    targetGradeIndex = grades.findIndex(function (grade) { return grade === targetGrade; });
                                    filters = {
                                        blockchainStates: [BlockchainState.MINTED],
                                        foil: targetFoil,
                                        mpcWalletOnly: true,
                                    };
                                    if (targetCard.advancement === CardAdvancement.STANDARD) {
                                        filters.ranks = ranks.filter(function (rank) { return rank < targetRank; });
                                    }
                                    if (targetCard.advancement === CardAdvancement.COMBO) {
                                        filters.grade = grades.filter(function (_grade, index) { return index >= targetGradeIndex; });
                                    }
                                    return [4 /*yield*/, gqlSdk.CardBattleFindManyByIan({
                                            input: {
                                                ian: ian_1,
                                                skip: 0,
                                                take: 200,
                                                sortOptions: [
                                                    { name: CardBattleSortName.POWER, direction: SortOrderDirection.ASC },
                                                    { name: CardBattleSortName.NUMBERING, direction: SortOrderDirection.DESC },
                                                ],
                                                filters: filters,
                                            },
                                        })];
                                case 1:
                                    cards = _c.sent();
                                    if (cardData) {
                                        resultedCard_1 = targetCard.advancement !== CardAdvancement.COMBO ||
                                            ((_a = cards.cardBattleFindManyByIan[0]) === null || _a === void 0 ? void 0 : _a.card.grade) === targetGrade
                                            ? cards.cardBattleFindManyByIan[0]
                                            : undefined;
                                        result.push({
                                            ian: ian_1,
                                            cards: cards.cardBattleFindManyByIan.filter(function (card) { return !card.card.isLocked; }),
                                            imageUrl: resultedCard_1
                                                ? generateCardImgUrl(ian_1, resultedCard_1.card.advancement, [resultedCard_1.card.element], targetFoil, resultedCard_1.card.rank, resultedCard_1.card.grade, 1)
                                                : generateCardImgUrl(ian_1, cardData.advancement, [cardData.elements[0]], targetFoil, cardData.advancement === CardAdvancement.STANDARD ? 1 : 5, cardData.advancement === CardAdvancement.STANDARD ? undefined : targetGrade, 1),
                                            selectedCard: resultedCard_1 === null || resultedCard_1 === void 0 ? void 0 : resultedCard_1.card,
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _i = 0, cardIans_1 = cardIans;
                    _b.label = 1;
                case 1:
                    if (!(_i < cardIans_1.length)) return [3 /*break*/, 4];
                    ian_1 = cardIans_1[_i];
                    return [5 /*yield**/, _loop_1(ian_1)];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    setServerLoading(false);
                    setCardsToSelect(result);
                    return [2 /*return*/];
            }
        });
    }); }, [targetCard, targetFoil, targetRank, targetGrade, usdcAddress, fees, imxClient, queue, parseCurrencyQuantity]);
    useEffect(function () {
        var card = cardsData.find(function (cardData) { return cardData.ian === ian; });
        if (!card)
            return;
        switch (card.advancement) {
            case CardAdvancement.STANDARD: {
                setCraftType(CraftType.POWER_UP);
                break;
            }
            case CardAdvancement.ALTERNATIVE: {
                setCraftType(CraftType.AWAKENING);
                break;
            }
            case CardAdvancement.COMBO: {
                setCraftType(CraftType.MERGE);
                break;
            }
            default: {
                setCraftType(undefined);
            }
        }
        var availableRanks = getAvailableRanksFromRarity(card.rarity, undefined);
        setTargetCard(card);
        setTargetRank(availableRanks[1]);
    }, [ian]);
    useEffect(function () {
        getCardsToSelect();
    }, [targetCard, targetFoil, targetRank, targetGrade]);
    useEffect(function () {
        function getCraftInfo() {
            return __awaiter(this, void 0, void 0, function () {
                var craftReady, craftStatus, craftData, craftStatus, craftData, cardsUuidToSacrifice, _i, cardsToSelect_1, card, mergeData;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            craftReady = !cardsToSelect.find(function (card) { return card.selectedCard === undefined; });
                            if (cardsToSelect.length === 0 || !craftReady) {
                                setTriselAmount(0);
                                setStoneAmount(0);
                                return [2 /*return*/];
                            }
                            if (!((targetCard === null || targetCard === void 0 ? void 0 : targetCard.advancement) === CardAdvancement.STANDARD && cardsToSelect[0].selectedCard)) return [3 /*break*/, 2];
                            return [4 /*yield*/, gqlSdk.CardGetCraftStatus({ input: { cardUuid: cardsToSelect[0].selectedCard.uuid } })];
                        case 1:
                            craftStatus = _c.sent();
                            craftData = (_a = craftStatus.cardGetCraftStatus.powerUpData) === null || _a === void 0 ? void 0 : _a.availableRanksToTarget.find(function (rank) { return rank.rank === targetRank; });
                            setTriselAmount((craftData === null || craftData === void 0 ? void 0 : craftData.priceData.currencyAmount) || 0);
                            setStoneAmount((craftData === null || craftData === void 0 ? void 0 : craftData.priceData.stoneAmount) || 0);
                            return [3 /*break*/, 7];
                        case 2:
                            if (!((targetCard === null || targetCard === void 0 ? void 0 : targetCard.advancement) === CardAdvancement.ALTERNATIVE && cardsToSelect[0].selectedCard)) return [3 /*break*/, 4];
                            return [4 /*yield*/, gqlSdk.CardGetCraftStatus({ input: { cardUuid: cardsToSelect[0].selectedCard.uuid } })];
                        case 3:
                            craftStatus = _c.sent();
                            craftData = (_b = craftStatus.cardGetCraftStatus.awakeningData) === null || _b === void 0 ? void 0 : _b.priceData;
                            setTriselAmount((craftData === null || craftData === void 0 ? void 0 : craftData.currencyAmount) || 0);
                            setStoneAmount((craftData === null || craftData === void 0 ? void 0 : craftData.stoneAmount) || 0);
                            return [3 /*break*/, 7];
                        case 4:
                            if (!(targetCard && targetCard.advancement === CardAdvancement.COMBO)) return [3 /*break*/, 6];
                            cardsUuidToSacrifice = [];
                            for (_i = 0, cardsToSelect_1 = cardsToSelect; _i < cardsToSelect_1.length; _i++) {
                                card = cardsToSelect_1[_i];
                                if (card.selectedCard) {
                                    cardsUuidToSacrifice.push(card.selectedCard.uuid);
                                }
                            }
                            return [4 /*yield*/, gqlSdk.CardMergeFillPreview({
                                    input: {
                                        targetIan: targetCard.ian,
                                        cardsUuidToSacrifice: cardsUuidToSacrifice,
                                        filters: {
                                            blockchainState: BlockchainState.MINTED,
                                            displayStrongest: false,
                                            foil: targetFoil,
                                        },
                                    },
                                })];
                        case 5:
                            mergeData = _c.sent();
                            setTriselAmount(mergeData.cardMergeFillPreview.priceData.currencyAmount || 0);
                            setStoneAmount(mergeData.cardMergeFillPreview.priceData.stoneAmount || 0);
                            return [3 /*break*/, 7];
                        case 6:
                            setTriselAmount(0);
                            setStoneAmount(0);
                            _c.label = 7;
                        case 7: return [2 /*return*/];
                    }
                });
            });
        }
        getCraftInfo();
    }, [cardsToSelect]);
    useEffect(function () {
        if ((dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.custom.type) !== DialogType.BUY_SINGLE_ASSET_FOR_CRAFT ||
            (!floorPrices[CurrencyTokenSymbol.CTA] && !floorPrices[CurrencyTokenSymbol.USDC])) {
            return;
        }
        var ctaFloorPrice = floorPrices[CurrencyTokenSymbol.CTA];
        var usdcFloorPrice = floorPrices[CurrencyTokenSymbol.USDC];
        var hasEnoughCurrencyCta = ctaFloorPrice
            ? checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, ctaFloorPrice.price.address || '', ctaFloorPrice.order.buy.data.quantity_with_fees)
            : true;
        var hasEnoughCurrencyUsdc = usdcFloorPrice
            ? checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, usdcFloorPrice.price.address || '', usdcFloorPrice.order.buy.data.quantity_with_fees)
            : true;
        setDialogProps({
            common: __assign(__assign({}, dialogProps.common), { actions: [
                    {
                        highlighted: true,
                        text: t('common.confirm'),
                        action: function () {
                            return buySingleAsset(selectedCurrency === CurrencyTokenSymbol.USDC && usdcFloorPrice
                                ? usdcFloorPrice.order.order_id
                                : (ctaFloorPrice === null || ctaFloorPrice === void 0 ? void 0 : ctaFloorPrice.order.order_id) || undefined);
                        },
                        disabled: (selectedCurrency === CurrencyTokenSymbol.USDC &&
                            usdcFloorPrice &&
                            (!hasEnoughCurrencyUsdc || (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address) === usdcFloorPrice.order.user)) ||
                            (selectedCurrency === CurrencyTokenSymbol.CTA &&
                                ctaFloorPrice &&
                                (!hasEnoughCurrencyCta || (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address) === ctaFloorPrice.order.user)),
                    },
                ] }),
            custom: __assign(__assign({}, dialogProps.custom), { selectedCurrency: selectedCurrency }),
        });
    }, [selectedCurrency]);
    function addSelection(selectedCard) {
        var cards = __spreadArray([], cardsToSelect, true);
        var selection = cards.find(function (card) { return card.ian === selectedCard.ian; });
        if (selection) {
            selection.imageUrl = generateCardImgUrl(selectedCard.ian, selectedCard.advancement, [selectedCard.element], targetFoil, selectedCard.rank, selectedCard.grade, 1);
            selection.selectedCard = selectedCard;
        }
        setCardsToSelect(cards);
    }
    function removeSelection(ian) {
        var cards = __spreadArray([], cardsToSelect, true);
        var selection = cards.find(function (card) { return card.ian === ian; });
        var cardData = cardsData.find(function (card) { return card.ian === ian; });
        if (selection && cardData) {
            selection.selectedCard = undefined;
            selection.imageUrl = generateCardImgUrl(ian, cardData.advancement, [cardData.elements[0]], targetFoil, cardData.advancement === CardAdvancement.STANDARD ? 1 : 5, cardData.advancement === CardAdvancement.STANDARD ? undefined : targetGrade, 1);
        }
        setCardsToSelect(cards);
    }
    function showBuySingleAssetDialog(ian) {
        return __awaiter(this, void 0, void 0, function () {
            var cardData, ranks, newFloorPrices, ctaFloorPrice, usdcFloorPrice, hasEnoughCurrencyCta, hasEnoughCurrencyUsdc, foil, newSelectedCurrency_1;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
            return __generator(this, function (_8) {
                switch (_8.label) {
                    case 0:
                        setImxLoading(true);
                        cardData = cardsData.find(function (card) { return card.ian === ian; });
                        if (!(user === null || user === void 0 ? void 0 : user.mpcWalletAddress) || !usdcAddress || !fees || !cardData || !targetCard)
                            return [2 /*return*/];
                        ranks = [1, 2, 3, 4, 5];
                        return [4 /*yield*/, getAssetSplittedFloorPrices(imxClient, usdcAddress, queue, fees, parseCurrencyQuantity, TokenType.CARD, {
                                ian: ian,
                                foil: targetFoil,
                                ranks: targetCard.advancement === CardAdvancement.STANDARD ? ranks.filter(function (rank) { return rank < targetRank; }) : undefined,
                                grades: targetCard.advancement === CardAdvancement.COMBO ? [targetGrade] : undefined,
                            })];
                    case 1:
                        newFloorPrices = _8.sent();
                        setFloorPrices(newFloorPrices);
                        ctaFloorPrice = newFloorPrices[CurrencyTokenSymbol.CTA];
                        usdcFloorPrice = newFloorPrices[CurrencyTokenSymbol.USDC];
                        if (ctaFloorPrice || usdcFloorPrice) {
                            hasEnoughCurrencyCta = ctaFloorPrice
                                ? checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, ctaFloorPrice.price.address || '', ctaFloorPrice.order.buy.data.quantity_with_fees)
                                : true;
                            hasEnoughCurrencyUsdc = usdcFloorPrice
                                ? checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, usdcFloorPrice.price.address || '', usdcFloorPrice.order.buy.data.quantity_with_fees)
                                : true;
                            foil = undefined;
                            if (ctaFloorPrice === null || ctaFloorPrice === void 0 ? void 0 : ctaFloorPrice.card)
                                foil = ctaFloorPrice.card.foil;
                            if (usdcFloorPrice === null || usdcFloorPrice === void 0 ? void 0 : usdcFloorPrice.card)
                                foil = usdcFloorPrice.card.foil;
                            newSelectedCurrency_1 = CurrencyTokenSymbol.CTA;
                            if (((_a = ctaFloorPrice === null || ctaFloorPrice === void 0 ? void 0 : ctaFloorPrice.price) === null || _a === void 0 ? void 0 : _a.usd) && !((_b = usdcFloorPrice === null || usdcFloorPrice === void 0 ? void 0 : usdcFloorPrice.price) === null || _b === void 0 ? void 0 : _b.usd))
                                newSelectedCurrency_1 = CurrencyTokenSymbol.CTA;
                            if (!((_c = ctaFloorPrice === null || ctaFloorPrice === void 0 ? void 0 : ctaFloorPrice.price) === null || _c === void 0 ? void 0 : _c.usd) && ((_d = usdcFloorPrice === null || usdcFloorPrice === void 0 ? void 0 : usdcFloorPrice.price) === null || _d === void 0 ? void 0 : _d.usd))
                                newSelectedCurrency_1 = CurrencyTokenSymbol.USDC;
                            if (((_e = ctaFloorPrice === null || ctaFloorPrice === void 0 ? void 0 : ctaFloorPrice.price) === null || _e === void 0 ? void 0 : _e.usd) && ((_f = usdcFloorPrice === null || usdcFloorPrice === void 0 ? void 0 : usdcFloorPrice.price) === null || _f === void 0 ? void 0 : _f.usd)) {
                                newSelectedCurrency_1 =
                                    ctaFloorPrice.price.usd.value > usdcFloorPrice.price.usd.value
                                        ? CurrencyTokenSymbol.USDC
                                        : CurrencyTokenSymbol.CTA;
                            }
                            setSelectedCurrency(newSelectedCurrency_1);
                            setImxLoading(false);
                            setDialogProps({
                                common: {
                                    preTitle: t('common.about-to-buy'),
                                    title: ((_g = ctaFloorPrice === null || ctaFloorPrice === void 0 ? void 0 : ctaFloorPrice.order.sell.data.properties) === null || _g === void 0 ? void 0 : _g.name) || ((_h = usdcFloorPrice === null || usdcFloorPrice === void 0 ? void 0 : usdcFloorPrice.order.sell.data.properties) === null || _h === void 0 ? void 0 : _h.name) || '',
                                    close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                                    actions: [
                                        {
                                            highlighted: true,
                                            text: t('common.confirm'),
                                            action: function () {
                                                return buySingleAsset(newSelectedCurrency_1 === CurrencyTokenSymbol.USDC && usdcFloorPrice
                                                    ? usdcFloorPrice.order.order_id
                                                    : (ctaFloorPrice === null || ctaFloorPrice === void 0 ? void 0 : ctaFloorPrice.order.order_id) || undefined);
                                            },
                                            disabled: (newSelectedCurrency_1 === CurrencyTokenSymbol.USDC &&
                                                usdcFloorPrice &&
                                                (!hasEnoughCurrencyUsdc || (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address) === usdcFloorPrice.order.user)) ||
                                                (newSelectedCurrency_1 === CurrencyTokenSymbol.CTA &&
                                                    ctaFloorPrice &&
                                                    (!hasEnoughCurrencyCta || (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address) === ctaFloorPrice.order.user)),
                                        },
                                    ],
                                },
                                custom: {
                                    type: DialogType.BUY_SINGLE_ASSET_FOR_CRAFT,
                                    cta: ctaFloorPrice
                                        ? {
                                            imgUrl: ((_j = ctaFloorPrice.order.sell.data.properties) === null || _j === void 0 ? void 0 : _j.image_url) || '',
                                            tokenId: ctaFloorPrice.order.sell.data.token_id || '',
                                            tokenAddress: ctaFloorPrice.order.sell.data.token_address || '',
                                            ownerAddress: ctaFloorPrice.order.user,
                                            numbering: (_k = ctaFloorPrice.card) === null || _k === void 0 ? void 0 : _k.numbering,
                                            metadata: {
                                                rarity: (_l = ctaFloorPrice.card) === null || _l === void 0 ? void 0 : _l.rarity,
                                                advancement: (_m = ctaFloorPrice.card) === null || _m === void 0 ? void 0 : _m.advancement,
                                                element: (_o = ctaFloorPrice.card) === null || _o === void 0 ? void 0 : _o.element,
                                                foil: foil,
                                                rank: ((_p = ctaFloorPrice.card) === null || _p === void 0 ? void 0 : _p.advancement) === CardAdvancement.STANDARD ? (_q = ctaFloorPrice.card) === null || _q === void 0 ? void 0 : _q.rank : undefined,
                                                grade: ((_r = ctaFloorPrice.card) === null || _r === void 0 ? void 0 : _r.grade) || undefined,
                                                faction: (_s = ctaFloorPrice.card) === null || _s === void 0 ? void 0 : _s.faction,
                                            },
                                            notEnoughCurrency: !hasEnoughCurrencyCta,
                                            price: {
                                                tokenSymbol: (_t = ctaFloorPrice.price.base) === null || _t === void 0 ? void 0 : _t.symbol,
                                                value: ((_u = ctaFloorPrice.price.base) === null || _u === void 0 ? void 0 : _u.displayValue) || '',
                                                usdValue: ((_v = ctaFloorPrice.price.usd) === null || _v === void 0 ? void 0 : _v.displayValue) || '',
                                            },
                                        }
                                        : undefined,
                                    usdc: usdcFloorPrice
                                        ? {
                                            imgUrl: ((_w = usdcFloorPrice.order.sell.data.properties) === null || _w === void 0 ? void 0 : _w.image_url) || '',
                                            tokenId: usdcFloorPrice.order.sell.data.token_id || '',
                                            tokenAddress: usdcFloorPrice.order.sell.data.token_address || '',
                                            ownerAddress: usdcFloorPrice.order.user,
                                            numbering: (_x = usdcFloorPrice.card) === null || _x === void 0 ? void 0 : _x.numbering,
                                            metadata: {
                                                rarity: (_y = usdcFloorPrice.card) === null || _y === void 0 ? void 0 : _y.rarity,
                                                advancement: (_z = usdcFloorPrice.card) === null || _z === void 0 ? void 0 : _z.advancement,
                                                element: (_0 = usdcFloorPrice.card) === null || _0 === void 0 ? void 0 : _0.element,
                                                foil: foil,
                                                rank: ((_1 = usdcFloorPrice.card) === null || _1 === void 0 ? void 0 : _1.advancement) === CardAdvancement.STANDARD
                                                    ? (_2 = usdcFloorPrice.card) === null || _2 === void 0 ? void 0 : _2.rank
                                                    : undefined,
                                                grade: ((_3 = usdcFloorPrice.card) === null || _3 === void 0 ? void 0 : _3.grade) || undefined,
                                                faction: (_4 = usdcFloorPrice.card) === null || _4 === void 0 ? void 0 : _4.faction,
                                            },
                                            notEnoughCurrency: !hasEnoughCurrencyCta,
                                            price: {
                                                tokenSymbol: (_5 = usdcFloorPrice.price.base) === null || _5 === void 0 ? void 0 : _5.symbol,
                                                value: ((_6 = usdcFloorPrice.price.base) === null || _6 === void 0 ? void 0 : _6.displayValue) || '',
                                                usdValue: ((_7 = usdcFloorPrice.price.usd) === null || _7 === void 0 ? void 0 : _7.displayValue) || '',
                                            },
                                        }
                                        : undefined,
                                    selectedCurrency: newSelectedCurrency_1,
                                    setSelectedCurrency: setSelectedCurrency,
                                },
                            });
                        }
                        else {
                            setImxLoading(false);
                            setDialogProps({
                                common: {
                                    title: t('craft.buy-dialog.no-result.title'),
                                    close: { text: t('common.back'), action: hideBuyDialog },
                                },
                                custom: {
                                    type: DialogType.SIMPLE,
                                    message: t('craft.buy-dialog.no-result.message'),
                                },
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function buySingleAsset(orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!selectedWallet || orderId === undefined)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.createTrade({
                                walletFrom: selectedWallet,
                                orderId: orderId,
                            })];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        if (err_1 instanceof Error) {
                            if (err_1.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_1.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_1.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 6];
                        return [4 /*yield*/, sleep(10000)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [4 /*yield*/, getCardsToSelect()];
                    case 7:
                        _b.sent();
                        setFloorPrices((_a = {}, _a[CurrencyTokenSymbol.CTA] = undefined, _a[CurrencyTokenSymbol.USDC] = undefined, _a));
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.buy-now'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('buy-now.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function confirmCraft() {
        return __awaiter(this, void 0, void 0, function () {
            var previousPower, card, result, burnCompleted, burnResult, card, result, burnCompleted, burnResult, card;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!((targetCard === null || targetCard === void 0 ? void 0 : targetCard.advancement) === CardAdvancement.STANDARD && ((_a = cardsToSelect[0]) === null || _a === void 0 ? void 0 : _a.selectedCard))) return [3 /*break*/, 3];
                        setServerLoading(true);
                        previousPower = cardsToSelect[0].selectedCard.nominalPower;
                        return [4 /*yield*/, gqlSdk.CraftPowerUp({
                                input: { targetRank: targetRank, cardToUpUuid: cardsToSelect[0].selectedCard.uuid },
                            })];
                    case 1:
                        _d.sent();
                        return [4 /*yield*/, gqlSdk.CardFindByUuid({
                                input: { cardUuid: cardsToSelect[0].selectedCard.uuid },
                            })];
                    case 2:
                        card = _d.sent();
                        setResultedCard(card.cardFindByUuid ? { card: card.cardFindByUuid, previousPower: previousPower } : undefined);
                        setServerLoading(false);
                        return [3 /*break*/, 23];
                    case 3:
                        if (!((targetCard === null || targetCard === void 0 ? void 0 : targetCard.advancement) === CardAdvancement.ALTERNATIVE && (user === null || user === void 0 ? void 0 : user.mpcWalletAddress))) return [3 /*break*/, 13];
                        setServerLoading(true);
                        return [4 /*yield*/, gqlSdk.CraftAwakenToAlt({
                                input: { cardToAwakenUuid: ((_c = (_b = cardsToSelect[0]) === null || _b === void 0 ? void 0 : _b.selectedCard) === null || _c === void 0 ? void 0 : _c.uuid) || '' },
                            })];
                    case 4:
                        result = _d.sent();
                        if (!result.craftAwakenToAlt.pendingBurn) return [3 /*break*/, 11];
                        setImxLoading(true);
                        return [4 /*yield*/, burnPendingBurn(imxActions, user.mpcWalletAddress, result.craftAwakenToAlt.pendingBurn.tokenIdsToBurn.map(function (tokenId) { return tokenId.id; }), WalletConnectionType.MPC, (user === null || user === void 0 ? void 0 : user.email) || '', (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || '')];
                    case 5:
                        _d.sent();
                        burnCompleted = false;
                        _d.label = 6;
                    case 6: return [4 /*yield*/, gqlSdk.BlockchainPendingBurnFindOne({
                            input: { pendingBurnUuid: result.craftAwakenToAlt.pendingBurn.uuid },
                        })];
                    case 7:
                        burnResult = _d.sent();
                        burnCompleted = burnResult.blockchainPendingBurnFindOne.status === ImxPendingBurnStatus.COMPLETED;
                        if (!!burnCompleted) return [3 /*break*/, 9];
                        return [4 /*yield*/, sleep(1000)];
                    case 8:
                        _d.sent();
                        _d.label = 9;
                    case 9:
                        if (!burnCompleted) return [3 /*break*/, 6];
                        _d.label = 10;
                    case 10:
                        setImxLoading(false);
                        _d.label = 11;
                    case 11: return [4 /*yield*/, gqlSdk.CardFindByUuid({ input: { cardUuid: result.craftAwakenToAlt.newCardUuid } })];
                    case 12:
                        card = _d.sent();
                        setResultedCard(card.cardFindByUuid ? { card: card.cardFindByUuid } : undefined);
                        setServerLoading(false);
                        return [3 /*break*/, 23];
                    case 13:
                        if (!((targetCard === null || targetCard === void 0 ? void 0 : targetCard.advancement) === CardAdvancement.COMBO && (user === null || user === void 0 ? void 0 : user.mpcWalletAddress))) return [3 /*break*/, 23];
                        return [4 /*yield*/, gqlSdk.CraftAwakenToAltCombo({
                                input: {
                                    targetIan: targetCard.ian,
                                    cardToSacrificeUuids: cardsToSelect.map(function (card) { var _a; return ((_a = card.selectedCard) === null || _a === void 0 ? void 0 : _a.uuid) || ''; }),
                                },
                            })];
                    case 14:
                        result = _d.sent();
                        if (!result.craftAwakenToAltCombo.pendingBurn) return [3 /*break*/, 21];
                        setImxLoading(true);
                        return [4 /*yield*/, burnPendingBurn(imxActions, user.mpcWalletAddress, result.craftAwakenToAltCombo.pendingBurn.tokenIdsToBurn.map(function (tokenId) { return tokenId.id; }), WalletConnectionType.MPC, (user === null || user === void 0 ? void 0 : user.email) || '', (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || '')];
                    case 15:
                        _d.sent();
                        burnCompleted = false;
                        _d.label = 16;
                    case 16: return [4 /*yield*/, gqlSdk.BlockchainPendingBurnFindOne({
                            input: { pendingBurnUuid: result.craftAwakenToAltCombo.pendingBurn.uuid },
                        })];
                    case 17:
                        burnResult = _d.sent();
                        burnCompleted = burnResult.blockchainPendingBurnFindOne.status === ImxPendingBurnStatus.COMPLETED;
                        if (!!burnCompleted) return [3 /*break*/, 19];
                        return [4 /*yield*/, sleep(1000)];
                    case 18:
                        _d.sent();
                        _d.label = 19;
                    case 19:
                        if (!burnCompleted) return [3 /*break*/, 16];
                        _d.label = 20;
                    case 20:
                        setImxLoading(false);
                        _d.label = 21;
                    case 21: return [4 /*yield*/, gqlSdk.CardFindByUuid({
                            input: { cardUuid: result.craftAwakenToAltCombo.newCardUuid },
                        })];
                    case 22:
                        card = _d.sent();
                        setResultedCard(card.cardFindByUuid ? { card: card.cardFindByUuid } : undefined);
                        setServerLoading(false);
                        _d.label = 23;
                    case 23: return [2 /*return*/];
                }
            });
        });
    }
    function hideBuyDialog() {
        var _a;
        setFloorPrices((_a = {}, _a[CurrencyTokenSymbol.CTA] = undefined, _a[CurrencyTokenSymbol.USDC] = undefined, _a));
        setDialogProps(undefined);
    }
    return {
        targetCard: targetCard,
        craftType: craftType,
        targetRank: targetRank,
        targetGrade: targetGrade,
        targetFoil: targetFoil,
        // usdAmount,
        stoneAmount: stoneAmount,
        triselAmount: triselAmount,
        acceptTerms: acceptTerms,
        cardsToSelect: cardsToSelect,
        resultedCard: resultedCard,
        setAcceptTerms: setAcceptTerms,
        setTargetRank: setTargetRank,
        setTargetGrade: setTargetGrade,
        setTargetFoil: setTargetFoil,
        addSelection: addSelection,
        removeSelection: removeSelection,
        showBuySingleAssetDialog: showBuySingleAssetDialog,
        confirmCraft: confirmCraft,
    };
}
